// 폰지킴 앱 userAgent 마커. 앱이 userAgent 에 넣어주는 문자열이며 소문자로 비교한다.
//
// 주의: UA 에 이 마커가 없는 구버전 앱은 "앱이 아님"으로 판정되어
// 네이티브 브릿지 호출(권한·차단앱·유심·위치)이 전부 실패한다.
// 마커를 넣은 앱 버전이 전 사용자에게 배포된 뒤에 운영에 반영해야 한다.
// 빈 문자열로 두면 게이트가 열려 마커 도입 전 동작으로 되돌아간다.
export const SAFEPHONE_UA_MARKER = 'safephone'

// 앱 웹뷰로 열린 커버 코드. 네이티브 브릿지를 쓸 수 있는 환경으로 본다.
// 폰지킴 웹은 uPass·kPass 앱 안에서도 열리므로 함께 포함한다.
export const APP_COVER_CODES = ['UPASSAPP', 'KPASSAPP', 'SAFEPHONEAPP']

export const readCoverGbnCd = () => {
  if (typeof window === 'undefined') return ''
  try {
    return sessionStorage.getItem('coverGbnCd') || ''
  } catch {
    return ''
  }
}

// pk(네이티브 브릿지)를 로드할 환경인가.
// deviceInfo 플러그인이 pk 플러그인보다 먼저 동기로 coverGbnCd 를 채우므로 여기서 읽을 수 있다.
export const shouldLoadPk = () => {
  // 마커 미설정 구간에서는 판정을 보류한다. 여기서 false 를 돌리면 앱 기능이 전부 죽는다.
  if (!SAFEPHONE_UA_MARKER) return true
  return APP_COVER_CODES.includes(readCoverGbnCd())
}
